/**
 * Anchoring Checklist
 * Before anchoring
 * Regulatory: WBC3 20
 */

export const ANCHORING_CHECKLIST = {
  id: 'anchoring',
  name: 'Anchoring',
  description: 'Before anchoring',
  icon: 'Anchor',
  regulatory: 'WBC3 20',
  isCustomisable: true,
  items: [
    { id: 'anch_1', text: 'Position suitable - clear of hazards and traffic', required: true },
    { id: 'anch_2', text: 'Depth and bottom type checked', required: true },
    { id: 'anch_3', text: 'Swinging room adequate', required: true },
    { id: 'anch_4', text: 'Anchor ready to let go', required: true },
    { id: 'anch_5', text: 'Anchor watch arrangements confirmed', required: false }
  ]
};
